class AboutIconWithText extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        const swiperEl = this.querySelector(".section-about-icon-with-text-slider");
        if (!swiperEl) return;

        const isMobile = window.matchMedia("(max-width: 767px)").matches;

        // Theme setting
        const mobileAutoScroll =
            this.dataset.mobileAutoScroll === "true";

        this.swiper = new Swiper(swiperEl, {
            slidesPerView: 1.1,
            spaceBetween: 0,
            loop: isMobile && mobileAutoScroll,

            speed: isMobile && mobileAutoScroll ? 6000 : 500,

            autoplay:
                isMobile && mobileAutoScroll
                    ? {
                        delay: 0,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                    }
                    : false,

            breakpoints: {
                540: {
                    slidesPerView: 1.8,
                },
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 3,
                },
            },
            navigation: {
                nextEl: this.querySelector(".swiper-button-next"),
                prevEl: this.querySelector(".swiper-button-prev"),
            },

            pagination: {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
            },
        });
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }
}

if (!customElements.get("about-icon-with-text")) {
    customElements.define("about-icon-with-text", AboutIconWithText);
}